import React, { useEffect, useState } from "react";
import "@/App.css";
import { Heart } from "lucide-react";
import { api, localDate } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Dashboard from "@/components/Dashboard";
import Gallery from "@/components/Gallery";
import LoveLetters from "@/components/LoveLetters";
import BucketList from "@/components/BucketList";
import FunZone from "@/components/FunZone";
import Journal from "@/components/Journal";
import PasswordGate from "@/components/PasswordGate";
import BackgroundDecor from "@/components/BackgroundDecor";
import WelcomeBurst from "@/components/WelcomeBurst";
import RiddleEditor from "@/components/RiddleEditor";

function App() {
  const [config, setConfig] = useState({
    partner_one: "Ayman",
    partner_two: "Samrah",
    anniversary: "2023-02-14",
    hug_count: 0,
  });
  const [surprise, setSurprise] = useState("");
  const [photos, setPhotos] = useState([]);
  const [letters, setLetters] = useState([]);
  const [bucket, setBucket] = useState([]);
  const [moods, setMoods] = useState([]);
  const [journal, setJournal] = useState([]);
  const [unlocked, setUnlocked] = useState(false);
  const [celebrate, setCelebrate] = useState(false);
  const [showRiddles, setShowRiddles] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleUnlock = () => {
    setUnlocked(true);
    setCelebrate(true);
    setTimeout(() => setCelebrate(false), 5000);
  };

  useEffect(() => {
    (async () => {
      try {
        const [c, s, p, l, b, m, j] = await Promise.all([
          api.get(`/config?client_date=${localDate()}`),
          api.get("/daily-surprise"),
          api.get("/photos"),
          api.get("/love-letters"),
          api.get("/bucket-list"),
          api.get("/moods"),
          api.get("/journal"),
        ]);
        setConfig(c.data);
        setSurprise(s.data.message);
        setPhotos(p.data);
        setLetters(l.data);
        setBucket(b.data);
        setMoods(m.data);
        setJournal(j.data);
      } catch (e) {
        console.error("load failed", e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const names = [config.partner_one, config.partner_two];

  if (loading) {
    return (
      <div className="paper-grain min-h-screen flex items-center justify-center">
        <Heart className="w-10 h-10 text-[#D95F59] fill-[#D95F59] animate-pulse" />
      </div>
    );
  }

  if (!unlocked) {
    return <PasswordGate onUnlock={handleUnlock} names={names} />;
  }

  return (
    <div className="App paper-grain min-h-screen">
      <BackgroundDecor />
      {celebrate && <WelcomeBurst name={config.partner_two} />}
      <div className="relative z-10">
        <Navbar names={names} onEditRiddles={() => setShowRiddles(true)} />
        <Dashboard config={config} setConfig={setConfig} surprise={surprise} />
        <Gallery photos={photos} setPhotos={setPhotos} />
        <LoveLetters letters={letters} setLetters={setLetters} names={names} />
        <Journal entries={journal} setEntries={setJournal} names={names} />
        <BucketList items={bucket} setItems={setBucket} />
        <FunZone
          config={config}
          setConfig={setConfig}
          moods={moods}
          setMoods={setMoods}
          names={names}
        />
        <footer className="text-center py-10 text-[#756D6A]">
          <p className="font-hand text-2xl text-[#D95F59]">
            made with love, for {config.partner_two} 💕
          </p>
        </footer>
      </div>
      <RiddleEditor open={showRiddles} onClose={() => setShowRiddles(false)} />
    </div>
  );
}

export default App;
